export const ScreenSize = {
   mobile: window.innerWidth < 769,
   desktop: window.innerWidth > 768
};
